import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch, loginUser, fetchProfile, logoutUser, clearError } from '@/store';
import { LoginRequest, User } from '@/constants/types';
import { USER_ROLES } from '@/constants/app';

export const useAuth = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user, token, isAuthenticated, isLoading, error } = useSelector(
    (state: RootState) => state.auth
  );

  // Scenario 2: Call profile API on page refresh when idToken exists
  useEffect(() => {
    if (token && !user && isAuthenticated) {
      dispatch(fetchProfile());
    }
  }, [token, user, isAuthenticated, dispatch]);

  // Scenario 1: Call profile API after login
  const login = async (loginData: LoginRequest) => {
    try {
      const result = await dispatch(loginUser(loginData)).unwrap();
      await dispatch(fetchProfile()).unwrap();
      return result;
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    await dispatch(logoutUser());
  };

  const clearAuthError = () => {
    dispatch(clearError());
  };

  const getNavigationPath = (user: User | null): string => {
    if (!user) return '/login';
    
    // Simplified navigation - only Administrator role supported for now
    switch (user.role) {
      case USER_ROLES.ADMINISTRATOR:
        return '/talky';
      case USER_ROLES.SUPER_ADMIN:
        return '/talky';
      default:
        return '/profile';
    }
  };

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    clearAuthError,
    getNavigationPath,
  };
};